// Script pour masquer les contrôles de quantité des produits gratuits/offerts
(function() {
    'use strict';
    
    function hideQuantityControls() {
        // Rechercher tous les éléments contenant les noms des produits
        const productNames = document.querySelectorAll('.cart-item__name, .cart-item__details a');
        
        productNames.forEach(nameElement => {
            const productName = nameElement.textContent.toLowerCase();
            
            // Vérifier si le nom contient "gratuit" ou "offert"
            if (productName.includes('gratuit') || productName.includes('offert')) {
                
                // Trouver l'élément parent qui contient le contrôle de quantité
                let cartItem = nameElement.closest('.cart-item, .cart-drawer-item');
                
                if (cartItem) {
                    // Masquer tous les contrôles de quantité dans cet item
                    const quantityControls = cartItem.querySelectorAll('quantity-input, .cart-item__quantity, .cart-drawer-item__quantity-and-prices .cart-item__quantity');
                    
                    quantityControls.forEach(control => {
                        control.style.display = 'none';
                    });
                    
                    // Alternative : masquer juste les boutons +/- tout en gardant la quantité visible
                    const quantityButtons = cartItem.querySelectorAll('.quantity__button');
                    quantityButtons.forEach(button => {
                        button.style.display = 'none';
                    });
                    
                    // Désactiver l'input de quantité
                    const quantityInputs = cartItem.querySelectorAll('.quantity__input');
                    quantityInputs.forEach(input => {
                        input.disabled = true;
                        input.style.pointerEvents = 'none';
                        input.style.backgroundColor = '#f5f5f5';
                    });
                }
            }
        });
    }
    
    // Fonction pour observer les changements dans le DOM (utile pour les sites dynamiques)
    function observeCartChanges() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    // Réexécuter la fonction si de nouveaux éléments sont ajoutés
                    setTimeout(hideQuantityControls, 100);
                }
            });
        });
        
        // Observer les changements dans le panier
        const cartContainers = document.querySelectorAll('[id*="cart"], [class*="cart"]');
        cartContainers.forEach(container => {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        });
    }
    
    // Exécuter au chargement de la page
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            hideQuantityControls();
            observeCartChanges();
        });
    } else {
        hideQuantityControls();
        observeCartChanges();
    }
    
    // Exécuter également après un délai pour s'assurer que tout est chargé
    setTimeout(hideQuantityControls, 500);
    setTimeout(hideQuantityControls, 1000);
    
})();